import { gql } from '@apollo/client';

export const CHANGE_GOODS_QUANTITY = gql`
  mutation changeGoodsQuantity($input: ChangeGoodsQuantityInput!) {
    changeGoodsQuantity(input: $input)
  }
`;
